import { error, valHooks } from 'jquery';
import React from 'react'


const checkNothing =  (fd) =>
{
    return true
}
const checkName = (fd)=>
{
    return (fd.name?.length < 1 ? [false, 'name', 'Name is required'] : [true, 'name']);
}

const checkLeadStatus = (fd)=>
{
    return (fd.leadStatus?.length < 1 ? [false, 'leadStatus', 'Lead Status is required'] : [true, 'leadStatus']);
}

const checkNextAction = (fd)=>
{
    return (fd.nextAction?.length < 1 ? [false, 'nextAction', 'Next Action is required'] : [true, 'nextAction']);
}

const checkEmail = (fd)=>
{
    return ( ((fd.email?.indexOf("@") > -1 ) && (fd.email.indexOf(".") > -1)) ? [true, 'email'] :  [false, 'email', 'Provide valid email'] );
}
const checkProjectTitle = (fd)=>
{
    return ( (fd.projectTitle?.length < 1 ? [false, 'projectTitle'] : [true, 'projectTitle']));
}

const checkProjectBudget = (fd)=>
{
    return ( (fd.projectBudget?.length < 1 ? [false, 'projectBudget', 'Please select budget'] : [true, 'projectBudget']));
}

const checkAgreeToTerms = (fd) =>
{

    return ( (fd.notAgreeToTerms == true ? [false, 'notAgreeToTerms', 'You must agree'] : [true, 'notAgreeToTerms']));
}


const validators = [checkName,  checkEmail, checkProjectTitle, checkProjectBudget, checkLeadStatus, checkNextAction, checkAgreeToTerms];

function checkAll(validators)
{

  
    return (fd, validatorInd) =>
    {
        
        let errors = [];
        let isValid = true;
    
       
        for(let validator of validators)
        {

           
            
            let [isValidIn, name, msg] = validator(fd) 
       
             
            if (fd.isRequired.includes(name))
            {

               if (validatorInd !== "checkNothing")
               {
                if ((!validatorInd) && (!isValidIn))
                    errors.push([name,msg])

                else if ((validator.name == validatorInd) && (!isValidIn))
                    errors.push([name,msg])
               }

                if (!isValidIn)
                {
                    isValid = false;
                  
                }
            }
            
        }
     

        return [errors, isValid];
    }
}

export const formValidator = checkAll(validators)